import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Flag, Grid, Icon, Button, Dropdown } from 'semantic-ui-react';
import api from 'api';
import actions from 'actions';
import { languages } from 'i18n';

class NavBar extends Component {

  participantLogout = () => api.participants.logout(() => {
    this.props.onParticipantLogout();
    this.props.onResponseLogout();
    this.props.onStageLogout();
    this.props.history.push('/');
  });

  render() {
    const { t, i18n, participantIsAuthenticated, participant } = this.props;
    return (
      <div className="nav-bar">
          <Grid>
            <Grid.Column computer={8} verticalAlign='middle'>

            </Grid.Column>
            <Grid.Column textAlign='right' computer={8}>
              {participantIsAuthenticated &&
                <div>
                  <Dropdown icon={null} direction='left'
                    trigger=<Button size='small'>{participant && participant.id} <Icon name='chevron down' style={{marginLeft: 4}}/></Button>
                  >
                    <Dropdown.Menu>
                      <Dropdown.Item content={t('trial.logout')} onClick={this.participantLogout}/>
                      <Dropdown.Divider />
                      <Dropdown.Header>{t('changeLanguage')}</Dropdown.Header>
                      {languages.map(l =>
                        <Dropdown.Item key={l.key} active={i18n.language === l.key} onClick={e => i18n.changeLanguage(l.key)}><Flag name={l.flag}/> {l.name}</Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              }
            </Grid.Column>
          </Grid>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  const participant = state.participants.participants.filter(p => state.participants.currentParticipantId === p._id)[0];
  const team = state.teams.teams.filter(t => participant && participant.team === t._id)[0];
  return { participantIsAuthenticated: state.participants.isAuthenticated, participant, team };
};
const mapDispatchToProps = dispatch => ({
  onParticipantLogout: () => dispatch(actions.participants.logout()),
  onResponseLogout: () => dispatch(actions.responses.logout()),
  onStageLogout: () => dispatch(actions.stages.logout()),
});

const NavBarContainer = withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavBar)));

export default NavBarContainer;
